module.exports = __webpack_public_path__ + "static/media/remita.038b184f.svg";